import * as Init from '../init.js';
import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as ADJUST from './adjust.res.js'
import * as COMMON from './common.res.js'

function getAdjustRpath(inData, adjustindex) {
    if (inData.mlayout === 'realtime') {
        return inData.modulepath + '/'
    }
    else {
        return inData.modulepath + "/" + CLAPI.getData(inData['workers'], 'pathname', adjustindex)
    }
}
function getAdjustClass(inData) {
    if (inData.mlayout === 'realtime') {
        return inData.modulename
    }
    else {
        const adjustindex = Init.getUserInfo(inData.modulename, 'adjustindex', 0)
        return CLAPI.getData(inData['workers'], 'pathname', adjustindex)
    }
}
function getAdjustIndex(inData) {
    if (inData.mlayout === 'realtime') {
        return 0
    }
    else {
        return Init.getUserInfo(inData.modulename, 'adjustindex', 0)
    }
}
function setTaskCtrl(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)
    COMMON.initTaskCtrl('任务列表')
    for (let index = 0; index < inData['workers'].datas.length; index++) {
        let adjustclass = CLAPI.getData(inData['workers'], 'pathname', index)
        adjustclass = adjustclass.split('-').pop();
        const wreap = CLAPI.getData(inData['money' + index.toString()], 'wreap', -1)
        const wfeem = 0 // CLAPI.getData(inData['money' + index.toString()], 'wfeem', -1)
        const asset = CLAPI.getData(inData['money' + index.toString()], 'ago_assets', 0)
        COMMON.incrTaskCtrlLeft(index, adjustclass, (wreap - wfeem) / asset)
    }
    const cvname = chartName + 'vleft'
    const curCfg = {
        layout: {
            offset: { // 图形的偏移位置（不包括标题等），margin为整个图形区，offset仅仅是图形
                left: 1,
                top: 1,
                right: 0,
                bottom: 1,
            },
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 4, // Y方向留空
            }
        },
        config: COMMON.CHART_LEFT_TASKS,
        rectMain: CLAPI.getChartRect(region)
    }
    
    curCfg.config.selectIndex = getAdjustIndex(inData)
    // console.log(curCfg.config.selectIndex);
    // const leftchart = 
    chart.createChart(cvname, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            inData.showDate = 0
            onLoadMData(inData, false, result.selectIndex)
        }
    })
}

function setDateCtrl(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)

    let adjustindex = getAdjustIndex(inData)
    let adjustclass = getAdjustClass(inData)
    
    if (inData.mlayout !== 'realtime') {
        adjustclass = adjustclass.split('-').pop();
    }
    const moneyname = 'dates' + adjustindex.toString()
    COMMON.initDateCtrl(adjustclass)
    for (let index = 0; index < inData[moneyname].datas.length; index++) {
        const cdate = CLAPI.getData(inData[moneyname], 'date', index)
        const vrate = CLAPI.getData(inData[moneyname], 'dreapr', index)
        COMMON.incrDateCtrlLeft(index, cdate, vrate)
    }

    const curCfg = {
        layout: {
            offset: { // 图形的偏移位置（不包括标题等），margin为整个图形区，offset仅仅是图形
                left: 1,
                top: 1,
                right: 0,
                bottom: 1,
            },
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 4, // Y方向留空
            }
        },
        config: COMMON.CHART_LEFT_DATES,
        rectMain: CLAPI.getChartRect(region)
    }
    // console.log(ADJUST.CHART_LEFT_DATES);
    const rdateindex = Init.getUserInfo(inData.modulename, 'rdateindex' + adjustindex.toString(), 0)
    curCfg.config.selectIndex = rdateindex
    
    // console.log(curCfg.config.selectIndex);
    // const leftchart = 
    chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        // console.log(result);
        
        if (result.event === 'btndown') {
            if (result.selectIndex === -1) {
                result.cancel = true
            }
            else {
                changeDate(inData, result.selectIndex)
            }
        }
    })
}

function setInfoCtrl(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)
    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
            layout: {
                title: {
                    pixel: 12, // 字体大小
                    height: 18, // 最大高度
                    spaceX: 10, // X方向留空
                    spaceY: 2, // Y方向留空
                }
            },
            config: ADJUST.CHART_ADJUST_INFOS,
            rectMain: curRect
        }
    const ainfoindex = Init.getUserInfo(inData.modulename, 'ainfoindex', 0)

    curCfg.config.selectIndex = ainfoindex
     
    const curchart = chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            Init.setUserInfo(inData.modulename, 'ainfoindex', result.selectIndex)
            drawAdjust(inData, false)
        }
    })
}

function setAdjustMerge(curChart, inData, region) {
    const chartName = inData.modulename
    const chart = curChart.getChart(chartName)
    const adjustindex = getAdjustIndex(inData)
    {
        const cvname = chartName + 'wreaps'
        const curRect = CLAPI.getChartRect(region, 1, 3, 0, 0)
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '合计盈亏',
                    },
                    axisY : {
                        left : {
                            display: 'both',
                            format : 'float',
                        },
                        right : {
                            format : 'float',
                        },
                    },
                    lines: ADJUST.AdjustGetLines(inData['workers'].datas.length, adjustindex, 'float'),
                },
                ADJUST.CHART_MONEY_HEAD),
            rectMain: curRect
        }
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // console.log('KBAR', result)
        })
        chart.bindData(curchart, cvname)
    }

    {
        const cvname = chartName + 'curholds'
        const curRect = CLAPI.getChartRect(region, 1, 3, 0, 1)
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '当日持仓',
                    },
                    axisY : {
                        left : {
                            display: 'both',
                            format : 'float',
                        },
                        right : {
                            format : 'float',
                        },
                    },
                    lines: ADJUST.AdjustGetLines(inData['workers'].datas.length, adjustindex, 'float'),
                },
                ADJUST.CHART_MONEY_HEAD),
            rectMain: curRect
        }
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // console.log('KBAR', result)
        })
        chart.bindData(curchart, cvname)
    }

    {
        const cvname = chartName + 'dreaps'
        const curRect = CLAPI.getChartRect(region, 1, 3, 0, 2)
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '单日盈亏',
                    },
                    axisY : {
                        left : {
                            display: 'both',
                            format : 'float',
                        },
                        right : {
                            format : 'float',
                        },
                    },
                    lines: ADJUST.AdjustGetLines(inData['workers'].datas.length, adjustindex, 'float'),
                },
                ADJUST.CHART_MONEY_FOOT),
            rectMain: curRect
        }
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // console.log('KBAR', result)
        })
        chart.bindData(curchart, cvname)
    }
}
function showDateCtrl(inData) {
    if (inData.mlayout === 'realtime') {
        return true
    }
    const showdate = Init.getUserInfo(inData.modulename, 'showdate', 'none') 
    if (showdate !== 'none') {
        return true
    }
    return false
}

function setAdjust(curChart, inData, region) {
    const chartName = inData.modulename
    const chart = curChart.getChart(chartName)
    const adjustindex = getAdjustIndex(inData)
    {
        const cvname = chartName + 'wreaps'
        const curRect = CLAPI.getChartRect(region, 1, 2, 0, 0)
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                },
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '累计盈亏',
                    },
                    lines: ADJUST.AdjustGetLines(inData['workers'].datas.length, adjustindex),
                },
                ADJUST.CHART_MONEY_HEAD),
            rectMain: curRect
        }
        if (inData.mlayout !== 'realtime') {
            curCfg.config['buttons'] = [{
                    clickName: 'showDate',
                    drawMethod: 'text', // 显示文本
                    clickInfo: [{
                            label: '显',
                            value: 'none'
                        },
                        {
                            label: '关',
                            value: 'show'
                        },
                    ],
                    }]
            CLAPI.ChartRes.setButtonValue(curCfg.config, 'showDate', Init.getUserInfo(inData.modulename, 'showdate', 'none'))
        }
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // console.log('KBAR', result)
            if (result.event === 'mousestop') {
                console.log('mousemove', result)
                if (!showDateCtrl(inData)) {
                    if (adjustindex !== -1 && result.data !== undefined) {
                        inData.showDate = result.data[0]
                        changeAdjust(inData)
                    }
                }
            }
            if (result.event === 'btndown') {
                if (result.name === 'showDate') {
                    if (result.info === 'none') {
                        Init.setUserInfo(inData.modulename, 'showdate', result.info)
                    }
                    else {
                        Init.setUserInfo(inData.modulename, 'showdate', result.info)    
                    }
                    drawAdjust(inData, false)
                }
            }
        })
        chart.bindData(curchart, cvname)
    }
    {
        const cvname = chartName + 'dreaps'
        const curRect = CLAPI.getChartRect(region, 1, 2, 0, 1)
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5
                }
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '当日盈亏',
                    },
                    lines: ADJUST.adjust_dreap_lines,
                },
                ADJUST.CHART_MONEY_FOOT),
            rectMain: curRect
        }
        curCfg.config['buttons'] = [{
            clickName: 'showHold',
                drawMethod: 'text', // 显示文本
                clickInfo: [{
                        label: '盈',
                        value: 'hold'
                    },
                    {
                        label: '仓',
                        value: 'reap'
                    },
                ],
            }]
        const showhold = Init.getUserInfo(inData.modulename, 'showhold', 'reap')
        if (showhold === 'hold') {
            curCfg.config.title.label = '当日仓位'
            curCfg.config.axisY.lines = 2
            curCfg.config.axisY.left.format = 'float'
            curCfg.config.axisY.right.format = 'float'
            curCfg.config.lines = ADJUST.adjust_dhold_lines
        }
        CLAPI.ChartRes.setButtonValue(curCfg.config, 'showHold', showhold)
        console.log(curCfg);
        
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // console.log('KBAR', result)
            if (result.event === 'btndown') {
                if (result.name === 'showHold') {
                    if (result.info === 'none') {
                        Init.setUserInfo(inData.modulename, 'showhold', result.info)
                    }
                    else {
                        Init.setUserInfo(inData.modulename, 'showhold', result.info)    
                    }
                    drawAdjust(inData, false)
                }
            }
        })
        chart.bindData(curchart, cvname)
    }

}

function showFminute(chart, inData, result) {
    const frect = {
        style:  'splitly',
        left: result.rect.left,
        top: 3 * Init.scale,
        width: result.rect.width,
        height: result.rect.top - 3 * Init.scale,
    }
    let curKey = inData['curKey']
    let minuDate = result.data[0]

    function onDrawMinute() {
        const curkinfo = {
            curdate : minuDate,
            coindot: 2,
            agoprc : CLAPI.getData(inData['minute'], 'agop', 0)
        }
        chart.setKeyWord(curKey, curkinfo)
        const axisXinfo = DATAS.AminuToAxisXinfo(inData['minute'], 'msec')
        chart.setAxisXinfo(axisXinfo.timeInfo, axisXinfo.dateInfo)
        chart.setTradeDate(minuDate)

        chart.initFwindow('fline', frect)
        const chartcfg = CLAPI.Utils.copyObjectOfDeep(CLAPI.ChartRes.CHART_FIXED_FIRST)  
        chartcfg.lines.push({
            className: CLAPI.ClDrawMark,
            info: {
                drawInfo : 'none',
                clrMethod  : 'getBSClr',
                drawMethod : 'strToMap',
                place : {
                    style : 'field', // top foot field
                    field : 'newp',
                },
                fieldY: 'bsflag',
            },
        })    
        const maincfg = {
            // layout: CLAPI.ChartRes.CHART_LAYOUT,
            layout: {
                offset: {
                    top: 5,
                    bottom: 10,
                    left: 5,
                    right: 10
                }
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    style: 'fwindow',
                },
                chartcfg),
            rectMain: CLAPI.getChartRect(frect, 1, 2, 0, 0)
        }
        maincfg.config.lines.push({
            className: CLAPI.ClDrawMark,
            info: {
                drawInfo : 'none',
                clrMethod  : 'getBSClr',
                drawMethod : 'strToMap',
                place : {
                    style : 'field', // top foot field
                    field : 'newp',
                },
                fieldY: 'bsflag',
            },
        })
        chart.openFwindow('kbar.minu', 'system.fixed', maincfg, function (result) {
            if (result.event === 'keydown') {
                chart.stopFwindow()
            }
        })
        const curvcfg = {
            layout: CLAPI.ChartRes.CHART_LAYOUT,
            config: CLAPI.Utils.mergeObjectOfDeep({
                    style: 'fwindow',
                    axisX: {
                        display: 'normal',
                    },
                },
                CLAPI.ChartRes.CHART_FIXED_SECOND),
            rectMain: CLAPI.getChartRect(frect, 1, 2, 0, 1)
        }
        chart.openFwindow('kbar.curv', 'system.fixed', curvcfg, function (result) {
            //  console.log(result)
        })
        
        const minus = ADJUST.getMinute(inData['minute'], curKey, inData['stock'], minuDate)
        // console.log(minus);
        chart.setFwindow('kbar.curv', minus)
        chart.setFwindow('kbar.minu', minus)
    }
    console.log(curKey, result);
    
    Init.sendCommand({
            cmds: {
                "minute": {
                    "cmd": "get",
                    "subject": curKey + ".alpha_minu1",
                    "service": "atdb/minu1",
                    "info": {
                        "sub-date": minuDate
                    }
                },
            }
        },
        function reply(datas) {
            if (Init.checkDatas(datas)) {
                inData['minute'] = datas['minute']
                console.log(inData);
                onDrawMinute()
            }
        });
}

function setAdjustKbar(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)

    const curKey = CLAPI.getData(inData['info'], 'code', -1)
    // 设置静态信息
    inData.keyWord = DATAS.AinfoToKeyWord(inData['info'])
    chart.setKeyWord(curKey, inData.keyWord.static)

    const adjustindex = getAdjustIndex(inData)
    
    const currdate = inData.showDate
    const opendate = CLAPI.getData(inData['money' + adjustindex.toString()], 'date',  0)
    const stopdate = CLAPI.getData(inData['money' + adjustindex.toString()], 'date', -1)
    console.log(opendate, stopdate, currdate);

    function getAdjustWindow(indata, opendate, stopdate, style) {
        let minIndex = 0
        let maxIndex = indata.datas.length - 1
        for (let index = 0; index < indata.datas.length; index++) {
            let curdate = indata.datas[index]
            if (style !== 'array') {
                curdate = CLAPI.getData(indata, 'date', index)
            }
            if (curdate >= opendate) {
                minIndex = index
                break
            }            
        }
        for (let index = indata.datas.length - 1; index >= 0; index--) {
            let curdate = indata.datas[index]
            if (style !== 'array') {
                curdate = CLAPI.getData(indata, 'date', index)
            }
            if (curdate <= stopdate) {
                maxIndex = index
                break
            }            
        }
        // console.log(minIndex, maxIndex, opendate, stopdate);
        
        minIndex = Math.max(0, minIndex - 30)  
        maxIndex = Math.min(indata.datas.length - 1, maxIndex + 30)    
        // console.log(minIndex, maxIndex);
        if (maxIndex < indata.datas.length - 1) {
            const recs = indata.datas.length - 1 - maxIndex
            indata.datas.splice(-1 * recs, recs)
        }
        if (minIndex > 0) {
            indata.datas.splice(0, minIndex)
        }
        // console.log(indata.datas);
        
        return indata.datas
    }
    // 设置坐标显示信息
    let axisXinfo = DATAS.AdateToAxisXinfo(inData['kbar'], 'msec')
    let kbarInfos = ADJUST.getKbar(inData['kbar'], inData['stock'])

    axisXinfo = getAdjustWindow({ datas : axisXinfo}, opendate, stopdate, 'array')
    chart.setAxisXinfo(axisXinfo)
    // 设置数据
    kbarInfos.datas = getAdjustWindow(kbarInfos, opendate, stopdate)
    chart.setData(chartName, kbarInfos)

    // console.log(axisXinfo, kbarInfos.datas);
    
    // 设置界面信息和绑定数据
    {
        const cvname = chartName + 'kbar'
        const curRect = CLAPI.getChartRect(region, 1, 2, 0, 0)
        const chartCfg = CLAPI.Utils.copyObjectOfDeep(CLAPI.ChartRes.CHART_KBAR_FIRST)
        chartCfg.buttons = [CLAPI.ChartRes.BUTTON_RIGHT]
        chartCfg.lines.push({
            className: CLAPI.ClDrawMark,
            info: {
                drawInfo : 'none',
                clrMethod  : 'getBSClr',
                drawMethod : 'strToMap',
                // place : {
                //     style : 'field', // top foot field
                //     field : 'newp',
                // },
                fieldY: 'bsflag',
            },
        })
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 10,
                    left: 5,
                    right: 10
                }
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: CLAPI.getData(inData['info'], 'name', -1) + ' ' + curKey,
                    },
                    scroll: { // 是否显示下方的游标
                        display: 'none' // 'none' does not show normal
                    },
                    axisY: {
                        left: {
                            display: 'none',
                        }
                    },
                },
                chartCfg),
            rectMain: curRect

        }
        const fchart = curChart.getChart('AdjustMinute')
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // console.log('KBAR', result)
            if (result.event === 'mouseout') {
                fchart.stopFwindow()
            }
            if (result.event === 'keydown') {
                if (result.code === 'space' || result.code === 'left' || result.code === 'right') {
                    showFminute(fchart, inData, result)
                }
            }
        })
        curchart.setWindowMark(opendate, stopdate, currdate)
        chart.bindData(curchart, chartName)
    }

    {
        const cvname = chartName + 'vbar'
        const curRect = CLAPI.getChartRect(region, 1, 2, 0, 1)
        const curCfg = {
            layout: {
                offset: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 10
                }
            },
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        display: 'none' // none 不显示 btn 按钮 text 文字
                    },
                    axisX: {
                        display: 'normal',
                    },
                    axisY: {
                        left: {
                            display: 'none',
                        }
                    },
                },
                CLAPI.ChartRes.CHART_KBAR_SECOND),
            rectMain:curRect
        }
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // console.log('VBAR', result)
        })
        chart.bindData(curchart, chartName)
    }
}
function readyAdjustInfo(curChart, inData) {
    const chartName = 'AdjustInfo'
    const chart = curChart.getChart(chartName)

    const ainfoindex = Init.getUserInfo(inData.modulename, 'ainfoindex', 0)
    if (ainfoindex === 1) {
        console.log(inData['assets']);
        
        chart.setData(chartName, inData['assets'])
    }
    else if (ainfoindex === 2) {
        chart.setData(chartName, ADJUST.getInfoCensus(inData['codeinfo']))
    }
    else if (ainfoindex === 3) {
        chart.setData(chartName, ADJUST.getInfoDetails(inData['stock']))
    }
    else {
        chart.setData(chartName, ADJUST.getInfoAdjust(inData['adjust']))
    }

}
function setAdjustInfo(curChart, chartName, inData, region) {
    const chart = curChart.getChart(chartName)

    // 设置数据
    const ainfoindex = Init.getUserInfo(inData.modulename, 'ainfoindex', 0)
    let tableInfo = ADJUST.AdjustInfo
    if (ainfoindex === 1) {
        tableInfo = ADJUST.AssetsInfo
    }
    else if (ainfoindex === 2) {
        tableInfo = ADJUST.CensusInfo
    }
    else if (ainfoindex === 3) {
        tableInfo = ADJUST.DetailsInfo
    }

    const mainLayoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 5,
                left: 5,
                right: 5
            }
        },
        config: CLAPI.Utils.mergeObjectOfDeep(
            {
                fieldlock  : 2,  // 按左键时，前面3个字段不动 
                fieldmins  : 5,       
                curKeyIdx  : 1,  // 用于检索curKey的字段索引
            }, CLAPI.ChartRes.CHART_TABLE),
        tableInfo : tableInfo,
        rectMain: CLAPI.getChartRect(region, 1, 1, 0, 0)
    }
    const mainchart = chart.createChart('user.main', 'system.table', mainLayoutCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        console.log(result);
        if (result.event === 'headclick') {
        }603269
        if (result.event === 'changeselect' || result.event === 'click') {
            if (ainfoindex !== 3) {
                onReadKey(inData, result.curCode)
            }
        }
        if (result.event === 'dataclick') {
        }
    })

    chart.bindData(mainchart, chartName)

}
function setAdjustBoard(curChart, chartName, inData, curRect) {
    const cvname = chartName + 'stock'
    const chart = curChart.getChart(chartName)  
    const adjustindex = getAdjustIndex(inData)
    console.log(inData['stocks']);
    
    // ADJUST.getWinmny(inData['stocks']);

    inData['codeinfo'] = ADJUST.getCodeInfo(inData['stocks'])
    chart.setData(cvname, ADJUST.getadjustInfo(inData['money' + adjustindex.toString()], inData['codeinfo']))
       
    const curCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: CLAPI.Utils.mergeObjectOfDeep(ADJUST.CHART_BOARD_ADJUST, CLAPI.ChartRes.CHART_BOARD),
        rectMain: curRect
    }
    const curchart = chart.createChart(cvname, 'system.board', curCfg, function (result) {
        //  console.log(result)
    })
    chart.bindData(curchart, cvname)
}
// function setStockBoard(curChart, chartName, inData, curRect) {
//     const cvname = chartName + 'stock'
//     const chart = curChart.getChart(chartName)  
    
//     chart.setData(cvname, ADJUST.getstockInfo(inData['info'], inData['stock']))
       
//     const curCfg = {
//         layout: CLAPI.ChartRes.CHART_LAYOUT,
//         config: CLAPI.Utils.mergeObjectOfDeep(ADJUST.CHART_BOARD_STOCK, CLAPI.ChartRes.CHART_BOARD),
//         rectMain: curRect
//     }
//     const curchart = chart.createChart(cvname, 'system.board', curCfg, function (result) {
//         //  console.log(result)
//     })
//     chart.bindData(curchart, cvname)
// }

function readyAdjust(curChart, inData) {
    const chartName = inData.modulename
    const chart = curChart.getChart(inData.modulename)
    const adjustindex = getAdjustIndex(inData)
    const moneyname = adjustindex == -1 ? 'money0' : 'money' + adjustindex.toString()

    const axisXinfo = DATAS.extractField(inData[moneyname], 'date')
    // 设置坐标显示信息
    chart.setAxisXinfo(axisXinfo)
    // console.log(axisXinfo);
    const wreaps = ADJUST.AdjustToData(inData[moneyname], 'wreap')
    chart.setData(chartName + 'wreaps', wreaps)

    const showinfo = Init.getUserInfo(inData.modulename, 'showhold', 'reap')
    if (showinfo === 'reap') {
        const dreaps = ADJUST.AdjustToData(inData[moneyname], 'dreap')
        chart.setData(chartName + 'dreaps', dreaps)
    }
    else {
        const dholds = ADJUST.AdjustToData(inData[moneyname], 'cur_holds', 'cur_assets')
        chart.setData(chartName + 'dreaps', dholds)
    }
}

function readyAdjustMerge(curChart, inData) {
    const chartName = inData.modulename
    const chart = curChart.getChart(inData.modulename)

    const adjustindex =  getAdjustIndex(inData)
    const moneyname = adjustindex == -1 ? 'money0' : 'money' + adjustindex.toString()
    const axisXinfo = DATAS.extractField(inData[moneyname], 'date')
    // 设置坐标显示信息
    chart.setAxisXinfo(axisXinfo)
    // console.log(axisXinfo);
    const wreaps = ADJUST.AdjustToDataRate(inData['workers'], inData, 'wreap', 'ago_assets')
    chart.setData(chartName + 'wreaps', wreaps)

    const dreaps = ADJUST.AdjustToDataRate(inData['workers'], inData, 'dreap', 'ago_assets')
    chart.setData(chartName + 'dreaps', dreaps)

    const curholds = ADJUST.AdjustToDataRate(inData['workers'], inData, 'cur_holds', 'cur_assets')
    chart.setData(chartName + 'curholds', curholds)

}
// 3 显示date列表
function drawAdjust(inData, isFirst) {

    console.log('Draw ====> Adjust Line')
    // console.log(JSON.stringify(inData));
    // console.log(inData);

    const curChart = Init.getSysChart()
    // 得到第一个窗口
    const canvas = Init.canvas
    let left = 130 * Init.scale

    if (isFirst) {
        // 设置为单一窗口 并返回第一个窗口
        const chart = curChart.initChart([inData.modulename, 'AdjustKbar', 'AdjustBoard', 'StockBoard', 'AdjustMinute', 'AdjustInfo', 'InfoCtrl', 'TaskCtrl', 'DateCtrl'])
        // 设置左部窗口
        if (inData.mlayout === 'realtime') {
            setDateCtrl(curChart, 'DateCtrl', inData, {
                style: 'sidebar',
                top: 0,
                left: 0,
                width: left - Init.scale,
                height: canvas.height,
            })
        }
        else {
            setTaskCtrl(curChart, 'TaskCtrl', inData, {
                style: 'sidebar',
                top: 0,
                left: 0,
                width: left - Init.scale,
                height: canvas.height,
            })
        }
    }

    if (inData.mlayout !== 'realtime') {
        const adjustindex = getAdjustIndex(inData)
        if (adjustindex === -1) {
            setAdjustMerge(curChart, inData, {
                style: 'average',
                top: 0,
                left: left,
                width: canvas.width - left,
                height: canvas.height,
            })
            readyAdjustMerge(curChart, inData)
            curChart.onPaint()
            return
        } 
    }
    
    const headh = canvas.height * 0.4
    const tailh = canvas.height - headh
    const right = (canvas.width - left) * 0.382

    if (inData.mlayout !== 'realtime') {
        const showdate = Init.getUserInfo(inData.modulename, 'showdate', 'none') 
        // console.log(showdate);
    
        if (showdate !== 'none')
        {
            const datewidth = 130 * Init.scale
            setDateCtrl(curChart, 'DateCtrl', inData, {
                style: 'sidebar',
                top: 0,
                left: left,
                width: datewidth - Init.scale,
                height: canvas.height,
            })
            left += datewidth
        }
        else {
            let curchart = curChart.getChart('DateCtrl')
            if (curchart) {
                curchart.destroyChart()
            }
            
        }
    }
    setAdjust(curChart, inData, {
        style: 'splitly',
        top: 0,
        left: left,
        width: canvas.width - left - right,
        height: headh,
    })
    setAdjustKbar(curChart, 'AdjustKbar', inData, {
        style: 'splitly',
        top: headh,
        left: left,
        width: canvas.width - left - right,
        height: tailh,
    })
    let bordh = canvas.height * 0.12
    setAdjustBoard(curChart, 'AdjustBoard', inData, {
        top: 0,
        left: canvas.width - right + Init.scale,
        width: right,
        height: bordh,
    })
    const nleft = canvas.width - right + Init.scale
    const infoh = 25 * Init.scale
    setInfoCtrl(curChart, 'InfoCtrl', inData, {
        style: 'sidebar',
        top: bordh,
        left: nleft,
        width: right,
        height: infoh,
    })
    setAdjustInfo(curChart, 'AdjustInfo', inData, {
        style: 'average',
        top: bordh + infoh,
        left: nleft,
        width: right,
        height: canvas.height - bordh - infoh,
    })

    readyAdjust(curChart, inData)
    
    readyAdjustInfo(curChart, inData)
    // console.log(curChart.chartList);
    curChart.onPaint()
}

function onReadKey(inData, curKey) {
    
    console.log(inData['adjust']);    
    // const startDate = CLAPI.getData(inData['money' + adjustindex.toString()], 'date', 0)
    if (curKey === undefined) {
        // 从调仓信息中获取
        curKey = ADJUST.AdjustGetKey(inData['stocks'])
    }
    inData['curKey'] = curKey
    
    const adjustindex = getAdjustIndex(inData)
    const adjustrpath = getAdjustRpath(inData, adjustindex)
    if (inData.showDate === 0) {
        inData.showDate = CLAPI.getData(inData['money' + adjustindex.toString()], 'date', 0);
    }
    const askDate = Math.min(inData.showDate, inData.diskDate)
    const cmds = {
        "kbar": {
            "cmd": "get",
            "subject": curKey + ".alpha_date",
            "service": "merge/ainfo",
            "info": {
                // "start-date": startDate
                "offset": 0
            }
        },
        "info": {
            "cmd": "get",
            "subject": curKey + ".alpha_info",
            "service": "merge/ainfo",
            "info": {
                "sub-date": askDate
                // "offset": -1
            }
        },
        "stock": {
            "cmd": "get",
            "subject": "adjust." + curKey,
            "service": adjustrpath + "/adjust/stocks/",
        },
    }
    if (inData.lastDate > inData.diskDate) {
        cmds['newbar'] = {
                "cmd" : "redis", 
                "subject" : "market", 
                "service": '47.242.109.110:17329', 
                "info" : {
                    "command" : "hget " + "market:kbar:" + inData.lastDate + " " + curKey
                }
            }
    }
    Init.sendCommand({ cmds },
        function reply(datas) {
            console.log(inData, datas);
            if (Init.checkDatas(datas, ['newbar', 'stock'])) {
                // inData['minu']  = datas['minu']
                inData['kbar']  = datas['kbar']
                inData['info']  = datas['info']
                if (datas['stock'].tag === 0) {
                    inData['stock'] = datas['stock']
                }
                else {
                    inData['stock'].datas = []
                }
                if (datas['newbar'] && datas['newbar'].infos) {
                    ADJUST.concatKbar(inData['kbar'], datas['newbar'])
                }
                drawAdjust(inData, true)
            }
            else {
                curKey =  ADJUST.AdjustGetKey(inData['stocks'])
                console.log(curKey);
                
                Init.setUserInfo(inData.modulename, 'curKey', curKey)
            }
        });
}

function changeAdjust(inData, isChange) {
    // 这里加载数据
    const adjustindex = getAdjustIndex(inData)
    const adjustrpath = getAdjustRpath(inData, adjustindex)
    const monyname = 'dates' + adjustindex.toString()
    // 这里每次都更新一下 确保当前任务为最新的
    console.log(inData[monyname], inData[monyname].newdate);
    
    if (inData[monyname].newdate) {
        inData.diskDate = CLAPI.getData(inData[monyname], 'date', 1)
    }
    else {
        inData.diskDate = CLAPI.getData(inData[monyname], 'date', 0)
    }
    if (inData.showDate === 0) {
        inData.showDate = CLAPI.getData(inData[monyname], 'date', 0)
    }

    let assetsdate = Math.min(inData.showDate, inData.diskDate)
    let adjustdate = inData.showDate
    if (inData.lastDate > inData.diskDate) {
        adjustdate = inData.showDate > inData.diskDate ? 0 : adjustdate
    }
    console.log(adjustdate, assetsdate, adjustindex, inData.showDate, inData.lastDate, inData.diskDate);
    
    const cmds = {
        "assets": {
            "cmd": "get",
            "subject": "assets",
            "service": adjustrpath + "/assets/",
            "info": {
                "sub-date": assetsdate
            }
        },
        "stocks": {
            "cmd": "get",
            "subject": "stock",
            "service": adjustrpath + "/census/",
        },
    }
    if (adjustdate > 0) {
        cmds["adjust"] = {
            "cmd": "get",
            "subject": "adjust",
            "service": adjustrpath + "/adjust/",
            "info": {
                "sub-date": adjustdate
            }
        }
    }
    if (inData.mlayout === 'realtime' ) {
        if (inData.lastDate > 0 && inData.lastDate > inData.diskDate) {
            cmds["nadjust"] = {
                "cmd" : "redis", 
                "subject" : "signal", 
                "service": '47.242.109.110:17329', 
                "info" : {
                    "command" : "lrange " + "adjust" + ":" + inData.modulename + ":" + inData.lastDate + " 0 -1"
                }
            }
        }
    }
    Init.sendCommand({ cmds },
        function reply(datas) {
            console.log(datas);
            if (Init.checkDatas(datas, ["adjust", 'nadjust'])) {
                inData['stocks'] = datas['stocks']
                if (inData.mlayout === 'realtime') {
                    if (inData.lastDate > 0 && inData.lastDate > inData.diskDate) {
                        inData['nadjust'] = ADJUST.getRealAdjust(datas['nadjust'])
                    }
                }
                if (inData.showDate <= inData.diskDate) {
                    inData['adjust'] = datas['adjust']
                    inData['assets'] = ADJUST.getInfoAssets(datas['assets'])
                }
                else {
                    inData['adjust'] = inData['nadjust']
                    inData['assets'] = ADJUST.rpsRealAssets(datas['assets'], inData['nadjust'])
                }
                console.log(inData['adjust'], inData.showDate, inData.diskDate);
                if (isChange) {
                    const curChart = Init.getSysChart()
                    readyAdjustInfo(curChart, inData)
                    curChart.onPaint()
                } 
                else {
                    onReadKey(inData)
                }
            }
        });
}

function changeDate(inData, newIndex) {
    // 这里新的索引是日期
    const adjustindex = getAdjustIndex(inData)
    const rdateindex = Init.getUserInfo(inData.modulename, 'rdateindex' + adjustindex.toString(), 0)
    // console.log(newIndex, rdateindex);
    if (newIndex < 0 || newIndex > inData['dates' + adjustindex.toString()].datas.length - 1) {
        newIndex = rdateindex
    }
    console.log(newIndex, rdateindex);
    
    if (newIndex !== rdateindex) {
        Init.setUserInfo(inData.modulename, 'rdateindex' + adjustindex.toString(), newIndex)
        inData.showDate = CLAPI.getData(inData['dates' + adjustindex.toString()], 'date',  newIndex)
        changeAdjust(inData, true)
    }    
}

function onLoadMData(inData, isFirst, newIndex) {
    let adjustindex = getAdjustIndex(inData)
    if (isFirst) {
        if (adjustindex < 0 || adjustindex > inData['workers'].datas.length - 1) {
            adjustindex = 0;
            Init.setUserInfo(inData.modulename, 'adjustindex', 0)
        }
        changeAdjust(inData)
    } 
    else {
        if (adjustindex === -1) {
            if (newIndex !== -1) {
                Init.setUserInfo(inData.modulename, 'adjustindex', newIndex)
                changeAdjust(inData)
            }
        } 
        else {
            if (newIndex === -1) {
                Init.setUserInfo(inData.modulename, 'adjustindex', newIndex)
                drawAdjust(inData, true)
            } 
            else {
                if (newIndex !== adjustindex) {
                    Init.setUserInfo(inData.modulename, 'adjustindex', newIndex)
                    changeAdjust(inData)
                } 
                else {
                    drawAdjust(inData, false)
                }
            }
        }
    }
}

export function onLoad(argvs) {
    let inData = {}
    inData.modulepath = argvs.modulepath ?? 'former/admix'
    inData.modulename = argvs.modulename ?? 'admix'
    inData.mlayout =  argvs.mlayout ?? "normal"
    inData.showDate = 0   // 当前显示的日期
    inData.lastDate = 0   // 是否有最新的日期
    inData.diskDate = 0   // 持仓中最新的日期
    console.log(argvs, inData);

    function onLoadMoney(inData) {
        const adjustindex = getAdjustIndex(inData)
        let cmds = {}
        for (let index = 0; index < inData['workers'].datas.length; index++) {
            const adjustrpath = getAdjustRpath(inData, index)
            cmds['money' + index.toString()] = {
                "cmd": "get",
                "subject": "money",
                "service": adjustrpath + "/census/",
                "info": {
                    "offset": 0
                },
            }
        }
        Init.sendCommand({
                cmds: cmds
            },
            function reply(datas) {
                if (Init.checkDatas(datas)) {    
                    for (let index = 0; index < inData['workers'].datas.length; index++) {
                        const mname = 'money' + index.toString()
                        inData[mname] = datas[mname]
                        inData['dates' + index.toString()] = ADJUST.moneyToDateinfo(datas[mname])
                    }
                    if (inData.lastDate > 0) {
                        ADJUST.incrNewDateinfo(inData['dates0'], inData.lastDate)
                    }
                    onLoadMData(inData, true)
                }
            });
    }
    if (inData.mlayout === 'realtime') {
        // 设置两个通用变量
        Init.sendCommand({
                cmds: {
                    "tradedate": {
                        "cmd" : "redis", 
                        "subject" : "tradedate", 
                        "service": '47.242.109.110:17329', 
                        "info" : {
                            "command" : "get " + "monitor:tradedate"
                        }
                    }
                }
            },
            function reply(datas) {
                // console.log(datas)
                if (Init.checkDatas(datas, ['tradedate'])) {
                    inData['workers'] = {
                        datas : [[0, inData.modulename]],
                        fields : {
                            index : 0,
                            pathname : 1
                        }
                    }
                    if (datas['tradedate'].tag === 0) {
                        inData.lastDate = datas['tradedate'].infos.currdate
                    }
                    Init.setUserInfo(inData.modulename, 'adjustindex', 0)
                    Init.setUserInfo(inData.modulename, 'rdateindex0', 0)
                    onLoadMoney(inData)
                }
            });
    }
    else {
        Init.sendCommand({
                cmds: {
                    "workers": {
                        "cmd": "paths",
                        "service": inData.modulepath + "/"
                    }
                }
            },
            function reply(datas) {
                // console.log(datas)
                if (Init.checkDatas(datas)) {
                    inData['workers'] = datas['workers']
                    inData['workers'].datas.sort((a,b) => b[1].localeCompare(a[1]))
                    onLoadMoney(inData)
                }
            });
    }
}

// 注册方法到参数表